import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "@/infrastructure/lib/utils"
import { useMagicFill } from "@/shared/contexts/MagicFillContext"

export interface InputProps extends React.ComponentProps<"input"> {
  error?: boolean
  fieldKey?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, fieldKey, disabled, ...props }, ref) => {
    const { isGlobalLoading, isFieldLoading } = useMagicFill();
    const isLoading = isGlobalLoading || (fieldKey ? isFieldLoading(fieldKey) : false);
    const isDisabled = disabled || isLoading;

    return (
      <div className="relative w-full">
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            error && "border-destructive focus-visible:ring-destructive",
            isLoading && "pr-9",
            className
          )}
          ref={ref}
          disabled={isDisabled}
          {...props}
        />
        {isLoading && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <Loader2 className="h-4 w-4 animate-spin text-primary" />
          </div>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
